export enum Organisation {
  MIN_OF_ENV = 'Ministry of Environment and Climate Change',
  MIN_OF_STATE_ENERGY = 'Ministry of State for Energy Affairs',
  MIN_OF_FINANCE = 'Ministry of Finance',
  MIN_OF_MUNICIPALITY = 'Ministry of Municipality',
  MIN_OF_TRANSPORT = 'Ministry of Transport',
  MIN_OF_COMMERCE = 'Ministry of Commerce and Industry',
  MIN_OF_HEALTH = 'Ministry of Public Health',
  MIN_OF_EDUCATION = 'Ministry of Education and Higher Education',
  MIN_OF_FOREIGN = 'Ministry of Foreign Affairs',
  MIN_OF_INTERIOR = 'Ministry of Interior',
  MIN_OF_DEFENCE = 'Ministry of Defence Affairs',
  MIN_OF_LABOUR = 'Ministry of Labour',
  MIN_OF_COMMS_TECH = 'Ministry of Communications and Information Technology',
  MIN_OF_CABINET = 'Ministry of State for Cabinet Affairs',
  MIN_OF_SOCIAL_DEV = 'Ministry of Social Development and Family',
  MIN_OF_CULTURE = 'Ministry of Culture',
  MIN_OF_LABOUR_SOCIAL = 'Ministry of Labour and Social Affairs',
  MIN_OF_PLANNING_STATS = 'Ministry of Development Planning & Statistics',
}
